import React, { FC } from 'react';
import { NamePath } from 'antd/lib/form/interface';
import dayjs from 'dayjs';
import { DateInput, Form } from '~/components';

export interface CreatedDataFromItemProps {
  label?: string;
  name: NamePath;
  filterCreatedDateTo: NamePath;
}

const CreatedDataFromItem: FC<CreatedDataFromItemProps> = (props) => {
  const { filterCreatedDateTo, name, label } = props;
  const today = dayjs();
  return (
    <Form.ShouldUpdate name={filterCreatedDateTo}>
      {(form) => {
        const selectedDateToString = form.getFieldValue(filterCreatedDateTo);
        const selectedDateTo = selectedDateToString ? dayjs(selectedDateToString) : undefined;
        return (
          <Form.Item label={label} name={name}>
            <DateInput
              disableDateRule={(date) => {
                if (selectedDateTo && date.isAfter(selectedDateTo)) return true;
                if (date.isAfter(today) && date.format('DD/MM/YYYY') !== today.format('DD/MM/YYYY')) return true;
                return false;
              }}
              size="middle"
              allowClear
            />
          </Form.Item>
        );
      }}
    </Form.ShouldUpdate>
  );
};

export default CreatedDataFromItem;
